import React from 'react';

const Pagination = ({ currentPage, totalRows, rowsPerPage, onPageChange }) => {
  const totalPages = Math.ceil(totalRows / rowsPerPage);

  const generatePages = () => {
    const pages = [];
    const pageNumbers = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pageNumbers.push(1, 2, 3, 4, totalPages);
      } else if (currentPage > totalPages - 3) {
        pageNumbers.push(1, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pageNumbers.push(1, currentPage - 1, currentPage, currentPage + 1, totalPages);
      }
    }

    pageNumbers.forEach((page, index) => {
      if (index > 0 && pageNumbers[index - 1] !== page - 1) {
        pages.push('...');
      }
      pages.push(page);
    });

    return pages;
  };

  const pages = generatePages();

  return (
    <nav className="d-flex justify-content-between align-items-center mt-20 pb-10">
      <p className="mb-0 text-dark">
        Total rows : <span className="fw-600">{totalRows}</span>
      </p>
      <ul className="pagination">
        {currentPage > 1 && (
          <>
            <li className="page-item">
              <button className="page-link" onClick={() => onPageChange(1)}>
                <i className="fa fa-angle-double-left" />
              </button>
            </li>
            <li className="page-item">
              <button className="page-link" onClick={() => onPageChange(currentPage - 1)}>
                <i className="fa fa-angle-left" />
              </button>
            </li>
          </>
        )}
        {pages.map((page, index) => (
          <li
            key={index}
            className={`page-item ${page === currentPage ? 'active' : ''} ${page === '...' ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => page !== '...' && onPageChange(page)}>
              {page}
            </button>
          </li>
        ))}
        {currentPage < totalPages && (
          <>
            <li className="page-item">
              <button className="page-link" onClick={() => onPageChange(currentPage + 1)}>
                <i className="fa fa-angle-double-right" />
              </button>
            </li>
            <li className="page-item">
              <button className="page-link" onClick={() => onPageChange(totalPages)}>
                <i className="fa fa-angle-right" />
              </button>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
};

export default Pagination;
